import { FONT_MONO } from '../../config/fonts';
import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { MyLocation } from "@mui/icons-material";

import { toDMS } from "../../utils/mapUtils";
import { CLOCK_THEMES } from "./MapClock";
import { glassSx } from "./overlayStyles";

export const MONO = FONT_MONO;   // shared font (config/fonts.js)

// Cursor position, bottom left of the map. mode: 'live' (Radar) | 'replay' (Review)
const LocationStatusBar = ({ position, mode = "live" }) => {
  const { accent } = CLOCK_THEMES[mode] || CLOCK_THEMES.live;

  return (
    <Box
      position="absolute"
      bottom={12}
      left={12}
      zIndex={1300}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.25,
        py: 0.6,
        borderRadius: "10px",
        color: "#fff",
        userSelect: "none",
        pointerEvents: "none",
        ...glassSx(accent),
      }}
    >
      <MyLocation sx={{ fontSize: "1rem", color: accent }} />

      <Box>
        {/* DMS */}
        <Typography
          sx={{
            fontFamily: MONO,
            fontSize: "0.8rem",
            fontWeight: 700,
            lineHeight: 1.3,
            color: accent,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {toDMS(position.lat, true)} &nbsp;{toDMS(position.lng, false)}
        </Typography>

        {/* Decimal */}
        <Typography
          sx={{
            fontFamily: MONO,
            fontSize: "0.68rem",
            lineHeight: 1.3,
            color: alpha("#fff", 0.7),
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {position.lat.toFixed(6)}, {position.lng.toFixed(6)}
        </Typography>
      </Box>
    </Box>
  );
};

export default LocationStatusBar;
